import { FC, Fragment } from 'react';
import { Link } from '../../../../components';
import { Box, Typography } from '@mui/material';
import { INeighborhoodPunchlist, ITopLevelJobPunchlist } from '../../../../models';
import { JobAccordion } from './job-accordion';

interface INeighborhoodAccordion {
  neighborhoodItem: INeighborhoodPunchlist;
  isAllAccodionsExpanded?: boolean;
}

export const NeighborhoodAccordion: FC<INeighborhoodAccordion> = ({
  neighborhoodItem,
  isAllAccodionsExpanded
}) => {
  return (
    <Box mb={1}>
      <Typography variant="h6" mb={0.5}>
        <Link
          to={`/production/punchlists/neighborhood-punchlists/${neighborhoodItem.neighborhoodId}`}
        >
          {neighborhoodItem.neighborhoodName}
        </Link>
      </Typography>
      {neighborhoodItem?.jobs?.map((job: ITopLevelJobPunchlist, index) => {
        return (
          <Fragment key={`${index}`}>
            <JobAccordion job={job} isAllAccodionsExpanded={isAllAccodionsExpanded} />
          </Fragment>
        );
      })}
    </Box>
  );
};
